/**
 * `/?spec=<key>`: the "Làm ảnh ngay" button of the spec guide pages (/quy-cach/…, scripts/export_spec_pages.py) opens
 * "Ảnh thẻ" with that spec chosen. Read once when the mode opens; once the catalogue is there the parameter leaves the
 * address (known key or not), so a reload or a copied link keeps whatever the user picks next.
 */
import type { Catalog } from "../api";

export const SPEC_GUIDE_PATH = "/quy-cach";
const PARAM = "spec";

/** The spec key in the address, or null. */
export function specParam(): string | null {
  return new URLSearchParams(window.location.search).get(PARAM);
}

/** That key when the catalogue has it; undefined (= the default spec) otherwise. */
export function knownSpec(catalog: Catalog, key: string | null): string | undefined {
  return key && catalog.specs.some((s) => s.key === key) ? key : undefined;
}

/** Removes `?spec=` from the address, keeping the path, any other parameter and the history entry. */
export function dropSpecParam(): void {
  const url = new URL(window.location.href);
  if (!url.searchParams.has(PARAM)) return;
  url.searchParams.delete(PARAM);
  window.history.replaceState(window.history.state, "", `${url.pathname}${url.search}${url.hash}`);
}
